"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _styles = require("@material-ui/core/styles");
var _DeleteOutline = _interopRequireDefault(require("@material-ui/icons/DeleteOutline"));
var _Remove = _interopRequireDefault(require("@material-ui/icons/Remove"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Chip = _interopRequireDefault(require("../Chip"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _Menu = _interopRequireDefault(require("../Menu"));
var _MenuItem = _interopRequireDefault(require("../MenuItem"));
var _SplitButton = _interopRequireDefault(require("../SplitButton"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    childrenWrapper: {
      flexGrow: 1,
      padding: theme.spacing(1.5, 1.5, 1.5, 0)
    },
    conditionGroupChildWrapper: {
      alignItems: 'center',
      display: 'flex',
      width: '100%'
    },
    conditionWrapper: {
      marginTop: theme.spacing(1)
    },
    connector: {
      background: theme.palette.grey[400],
      border: 0,
      height: '1px',
      margin: 0,
      minWidth: theme.spacing(1.5),
      width: theme.spacing(1.5)
    },
    container: {
      border: "1px solid ".concat(theme.palette.grey[400]),
      display: 'flex',
      minHeight: 72
    },
    groupHeader: {
      alignItems: 'center',
      backgroundColor: theme.palette.grey[100],
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      width: 70
    },
    icon: {
      margin: theme.spacing(1, 0, 1, 0)
    }
  };
});
var defaultProps = {
  chipDropdownOptions: [{
    label: 'AND',
    value: 'and'
  }, {
    label: 'OR',
    value: 'or'
  }],
  dataMetrics: {
    conditions: 'fuse_expanded_conditions',
    header: 'fuse_expanded_condition_group_header',
    root: 'fuse_expanded_condition_group'
  },
  lowerIcon: /*#__PURE__*/_react["default"].createElement(_DeleteOutline["default"], null),
  readonlyMode: false,
  upperIcon: /*#__PURE__*/_react["default"].createElement(_Remove["default"], null)
};

/**
 * This pattern is used to visualize and manipulate the logic relationship of conditions which might be complicated. E.g. ((A & B) || C || (D & E)) & (F || G).
 */
var ExpandedConditionGroup = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var children = props.children,
    chipDropdownOptions = props.chipDropdownOptions,
    ChipProps = props.ChipProps,
    className = props.className,
    dataMetrics = props.dataMetrics,
    id = props.id,
    lowerIcon = props.lowerIcon,
    LowerIconButtonProps = props.LowerIconButtonProps,
    onChangeChipCallback = props.onChangeChipCallback,
    onLowerIconButtonClick = props.onLowerIconButtonClick,
    onUpperIconButtonClick = props.onUpperIconButtonClick,
    readonlyMode = props.readonlyMode,
    SplitButtonProps = props.SplitButtonProps,
    upperIcon = props.upperIcon,
    UpperIconButtonProps = props.UpperIconButtonProps;
  var classes = useStyles();
  var anchorElRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    menuOpen = _useState2[0],
    setMenuOpen = _useState2[1];
  var getPseudoId = function getPseudoId(prefix) {
    return "".concat(prefix, "-").concat(Math.random(), "-").concat(new Date().getTime());
  };
  var handleToggleMenu = function handleToggleMenu(nextMenuOpen) {
    return function () {
      return setMenuOpen(nextMenuOpen);
    };
  };
  var handleMenuItemClick = function handleMenuItemClick(value) {
    handleToggleMenu(false)();
    onChangeChipCallback(value);
  };
  var ChildWrapper = (0, _react.useMemo)(
  // eslint-disable-next-line react/no-unstable-nested-components
  function () {
    return function (child) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.conditionGroupChildWrapper
      }, /*#__PURE__*/_react["default"].createElement("hr", {
        className: classes.connector
      }), child);
    };
  }, [classes.conditionGroupChildWrapper, classes.connector]);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.container, className),
    "data-metrics": mergedDataMetrics.root,
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.groupHeader,
    "data-metrics": mergedDataMetrics.header
  }, !readonlyMode && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], (0, _extends2["default"])({
    className: classes.icon,
    color: "inherit",
    onClick: function onClick() {
      return onUpperIconButtonClick({
        id: id
      });
    }
  }, UpperIconButtonProps), upperIcon), /*#__PURE__*/_react["default"].createElement(_Chip["default"], (0, _extends2["default"])({
    "aria-controls": "menu-".concat(id),
    clickable: true,
    onClick: readonlyMode ? undefined : handleToggleMenu(true),
    onDropDown: readonlyMode ? undefined : handleToggleMenu(!menuOpen),
    label: "OR",
    ref: anchorElRef,
    size: "small"
  }, ChipProps, {
    disabled: readonlyMode,
    "aria-disabled": readonlyMode
  })), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    anchorEl: anchorElRef.current,
    id: "menu-".concat(id),
    open: menuOpen,
    onClose: handleToggleMenu(false)
  }, chipDropdownOptions.map(function (_ref) {
    var label = _ref.label,
      value = _ref.value,
      menuItemDataMetrics = _ref['data-metrics'];
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      "data-metrics": menuItemDataMetrics,
      key: value,
      onClick: function onClick() {
        return handleMenuItemClick(value);
      }
    }, label);
  })), !readonlyMode && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], (0, _extends2["default"])({
    className: classes.icon,
    color: "inherit",
    onClick: function onClick() {
      return onLowerIconButtonClick({
        id: id
      });
    }
  }, LowerIconButtonProps), lowerIcon)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.childrenWrapper,
    "data-metrics": mergedDataMetrics.conditions
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    direction: "row",
    spacing: 1
  }, Array.isArray(children) ? children.map(function (child, idx) {
    return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      item: true,
      xs: 12,
      key: getPseudoId(idx)
    }, ChildWrapper(child));
  }) : /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12
  }, ChildWrapper(children))), !readonlyMode && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.conditionWrapper
  }, ChildWrapper( /*#__PURE__*/_react["default"].createElement(_SplitButton["default"], SplitButtonProps)))));
});
ExpandedConditionGroup.displayName = 'ExpandedConditionGroup';
ExpandedConditionGroup.defaultProps = defaultProps;
ExpandedConditionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The content of the component.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].arrayOf(_propTypes["default"].node)]).isRequired,
  /**
   * The options to pass to the chip dropdown.
   */
  chipDropdownOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].any
  })),
  /**
   * The props to pass to the ```Chip``` component.
   */
  ChipProps: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    conditions: _propTypes["default"].string,
    header: _propTypes["default"].string,
    root: _propTypes["default"].string
  }),
  /**
   * The identifier of the group
   */
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /**
   * The lower icon element.
   */
  lowerIcon: _propTypes["default"].element,
  /**
   * The props to pass to the ```IconButton``` component.
   */
  LowerIconButtonProps: _propTypes["default"].object,
  /**
   * Callback fired when the Chip label is changed.
   */
  onChangeChipCallback: _propTypes["default"].func,
  /**
   * Callback fired when the IconButton is clicked.
   */
  onLowerIconButtonClick: _propTypes["default"].func.isRequired,
  /**
   * Callback fired when the IconButton is clicked.
   */
  onUpperIconButtonClick: _propTypes["default"].func.isRequired,
  /**
   * If readonly, the split button will be hidden along with the other action buttons.
   */
  readonlyMode: _propTypes["default"].bool,
  /**
   * The props to pass to the ```SplitButton``` component.
   *
   * `id: string` - **required** <br>
   *  `menuItems: array` - **required**
   *
   * ```
   *  [{
   *    label: string | node - required
   *    leftIcon: node
   *    onClick: func - required
   *   }]
   * ```
   * `primaryButtonProps: object` - **required**
   *
   * ```
   *  {
   *    aria-label: string
   *    children: string | node - required
   *    icon: node
   *    onClick: func - required
   *  }
   * ```
   */
  SplitButtonProps: _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    menuItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
      leftIcon: _propTypes["default"].node,
      onClick: _propTypes["default"].func.isRequired
    })).isRequired,
    primaryButtonProps: _propTypes["default"].shape({
      'aria-label': _propTypes["default"].string,
      children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
      icon: _propTypes["default"].node,
      onClick: _propTypes["default"].func.isRequired
    }).isRequired
  }).isRequired,
  /**
   * The upper icon element.
   */
  upperIcon: _propTypes["default"].element,
  /**
   * The props to pass to the ```IconButton``` component.
   */
  UpperIconButtonProps: _propTypes["default"].object
} : {};
var _default = ExpandedConditionGroup;
exports["default"] = _default;